/**
 * Proposal Tags Component
 * Displays tags/labels for a proposal
 */
export function ProposalTags({ tags, onTagClick, compact = false }) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className={`t24-proposal-tags ${compact ? 'compact' : ''}`}>
      {tags.map((tag, index) => (
        <span
          key={index}
          className="t24-tag"
          onClick={(e) => {
            if (onTagClick) {
              e.stopPropagation();
              onTagClick(tag);
            }
          }}
          role={onTagClick ? 'button' : 'text'}
          tabIndex={onTagClick ? 0 : -1}
          onKeyDown={(e) => {
            if (onTagClick && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              e.stopPropagation();
              onTagClick(tag);
            }
          }}
        >
          #{tag}
        </span>
      ))}
    </div>
  );
}
